export function disponibilitaBackButton(state,setPath, handlerStateDialogMappaDisponibilita) {
     handlerStateDialogMappaDisponibilita(old => {
               if(old) {
                    return false
               } else {
                    return old
               }
     })
     setPath(state.length - 2)
}